import { createTheme } from '../utils';
import * as Loader from './components/Loader.css';
export const defaultTheme = {
    Loader
};
export const { useTheme } = createTheme(defaultTheme);
